export const areObjectsEqual = (obj1, obj2) => {
  if (obj1 === null && obj2 === null) {
    return true;
  }
  if (obj1 === null || obj2 === null) {
    return false;
  }

  if (typeof obj1 !== typeof obj2) {
    return false;
  }

  if (Array.isArray(obj1)) {
    if (!Array.isArray(obj2)) {
      return false;
    }

    if (obj1.length !== obj2.length) {
      return false;
    }

    return obj1.every((item, index) => areObjectsEqual(item, obj2[index]));
  }

  if (typeof obj1 === "object") {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    return keys1.every((key) => {
      if (!Object.prototype.hasOwnProperty?.call(obj2, "bar")) {
        return false;
      }
      return areObjectsEqual(obj1[key], obj2[key]);
    });
  }

  return obj1 === obj2;
};
